<template>
  <div class="d-flex flex-column">
    <div class="d-flex cloud-menu">
      <RexSearchSelect
        :current="currentCloud"
        :data="vendors"
        width="15.75rem"
        @onChoose="(item) => onCloudChange(item)"
        :heading="this.$t('selectCloud')"
        :objectValueIndex="1"
        class="capability-dropdown"
        id="search-select-cloud"
      />
      <RexSearchSelect
        :current="getCloudSvc"
        :data="svcs"
        width="10.75rem"
        @onChoose="(item) => onServiceChange(item)"
        :heading="this.$t('selectService')"
        :objectValueIndex="1"
        class="capability-dropdown"
        id="search-select-cloud"
      />
    </div>
    <div class="main-container">
      <CloudServicesContainer />
    </div>
  </div>
</template>
<script>
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import { mapActions, mapState } from 'vuex';
import { CloudService } from '@/services/api/integration.service';
import { notificationError } from '@/utils/notification';
import CloudServicesContainer from '@/components/Cloud/services/cloud-service-container';
import {
  MESSAGES,
  URL_MAP,
  VENDORS,
  SVC,
  FALLBACKS,
  SVC_DISPLAY,
  SVC_SUBTYPE,
} from '@/components/Cloud/services/util';
export default {
  components: { RexSearchSelect, CloudServicesContainer },
  data() {
    return {
      vendors: [],
      currentCloud: '',
      svcs: [],
      currentSvc: '',
    };
  },
  methods: {
    ...mapActions('cloudState/integrations', ['GET_VENDOR']),
    ...mapActions('cloudState/services', [
      'SET_CURRENT_SERVICE',
      'SET_CURRENT_VENDOR',
    ]),
    async onCloudChange(selectedCloud) {
      this.currentCloud = selectedCloud;

      const {
        data: { success },
      } = await this.fetchServices(this.currentCloud.id);
      if (success) {
        if (this.svcs.length == 0) {
          this.currentSvc = '';
        } else this.currentSvc = this.svcs[0];

        if (this.currentCloud && this.currentCloud.name) {
          if (this.currentCloud.name === 'AZURE') {
            this.pushToUrl(URL_MAP.AZURE);
          } else {
            this.pushToUrl(
              URL_MAP[this.currentCloud.name][this.currentSvc.label],
            );
          }
          this.setVendor(this.currentCloud.name);
          this.setSvc(this.currentSvc.label);
        }
      } else {
        this.currentSvc = '';
        this.currentCloud = '';
        notificationError(MESSAGES.ERROR.SVC_LIST_FAILED);
      }
    },
    onServiceChange(service) {
      this.currentSvc = {
        ...service,
        label: SVC_SUBTYPE[service.label] || service.label,
      };

      this.SET_CURRENT_SERVICE(this.currentSvc.label);
      this.pushToUrl(
        URL_MAP[this.currentCloud.name || this.currentCloud][
          this.currentSvc.label?.toUpperCase()
        ],
      );
    },
    pushToUrl(url) {
      if (url === undefined) url = URL_MAP.GCP.GKE;
      this.$router.push(`/cloud/${url}`);
      // history.pushState({}, null, `/${this.$route.name}/${url}`);
    },
    setVendor(vendorName) {
      VENDORS[vendorName] !== undefined
        ? this.SET_CURRENT_VENDOR(vendorName)
        : this.SET_CURRENT_VENDOR(FALLBACKS.VENDOR);
    },
    setSvc(svcName) {
      SVC[svcName] !== undefined
        ? this.SET_CURRENT_SERVICE(svcName)
        : this.SET_CURRENT_SERVICE(FALLBACKS.SVC);
    },
    async fetchServices(currentCloudId) {
      if (!currentCloudId) {
        this.svcs = [];
        return;
      }
      const { data } = await CloudService.getVendorSvc(currentCloudId);
      const { success, services } = data;
      if (success) {
        this.svcs = services.map((svc) => {
          return {
            id: svc.serviceId,
            label: SVC_DISPLAY[svc.name],
          };
        });
      }
      return { data: { success, services } };
    },
  },
  async mounted() {
    await this.GET_VENDOR();
    await this.fetchServices(this.currentCloud.id);
  },
  watch: {
    async available(newVal) {
      this.vendors = newVal?.map((v) => {
        return {
          id: v.vendorId,
          name: v.name,
        };
      });

      await this.fetchServices(
        this.vendors.find((vendor) => vendor.name === this.cloudVendor).id,
      );
    },
    '$route.name': {
      handler: function (currentRoute) {
        if (currentRoute === 'cloud') {
          if (this.cloudVendor && this.cloudSvc) {
            this.currentCloud = this.cloudVendor;
            if (this.cloudVendor === VENDORS.AZURE) {
              this.pushToUrl(URL_MAP.AZURE);
              this.currentSvc = '';
            } else {
              this.currentSvc = this.cloudSvc;
              this.pushToUrl(URL_MAP[this.cloudVendor][this.cloudSvc]);
            }
          }
        }
      },
    },
  },
  computed: {
    ...mapState('cloudState/integrations', ['available']),
    ...mapState('cloudState/services', ['cloudVendor', 'cloudSvc']),
    getCloudSvc() {
      return SVC_DISPLAY[this.cloudSvc];
    },
  },
  created() {
    if (this.cloudVendor && this.cloudSvc) {
      this.currentCloud = this.cloudVendor;
      if (this.cloudVendor === VENDORS.AZURE) {
        this.pushToUrl(URL_MAP.AZURE);
        this.currentSvc = '';
      } else {
        this.currentSvc = this.cloudSvc;
        this.pushToUrl(URL_MAP[this.cloudVendor][this.cloudSvc]);
      }
    }
    // this.SET_CURRENT_VENDOR(VENDORS.GCP);
    // this.SET_CURRENT_SERVICE(SVC.GKE);
  },
};
</script>
<style scoped>
.cloud-menu {
  gap: 5rem;
}
.main-container {
  display: flex;
  flex-direction: column;
}
</style>
